import '@ungap/url-search-params';

import React from 'react';
import ReactDOM from 'react-dom';
import PaymentsApplication from 'app/PaymentsApplication';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker'

import { IntlProvider } from "react-intl";
import messages_en from "./i18n/en.json";
import messages_zh from "./i18n/zh.json";

// Logger with default options
import logger from "redux-logger";
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from "react-redux";

import bulkFxUpdateReducer from "./rx/bulkfxupdate/bulkFxUpdateReducer";
import orderExportReducer from "./rx/orders/orderExportReducer";
import userReducer from "./rx/user/userReducer";
import dashboardReducer from "./rx/dashboard/dashboardReducer";
import transactionHistoryReducer from "./rx/transactionhistory/transactionHistoryReducer";
import addVaSettleReducer from "./rx/addvasettle/addVaSettleReducer";
import selectOriginatorReducer from "./rx/selectoriginator/selectOriginatorReducer";
import selectRelationshipReducer from "./rx/selectrelationship/selectRelationshipReducer";
import selectSourceOfFundReducer from "./rx/selectsourceoffund/selectSourceOfFundReducer";
import selectPurposeOfTransferReducer from "./rx/selectpurposeoftransfer/selectPurposeOfTransferReducer";
import documentUploadReducer from "./rx/documentupload/documentUploadReducer";


//////////////////////////////////////////
// Redux
//////////////////////////////////////////
const reducer = {
  bulkFxUpdate: bulkFxUpdateReducer,
  orderExport: orderExportReducer,
  user: userReducer,
  dashboard: dashboardReducer,
  transactionHistory: transactionHistoryReducer,
  addVaSettle: addVaSettleReducer,
  selectOriginator: selectOriginatorReducer,
  selectRelationship: selectRelationshipReducer,
  selectSourceOfFund: selectSourceOfFundReducer,
  selectPurposeOfTransfer: selectPurposeOfTransferReducer,
  documentUpload: documentUploadReducer,
};

const store = configureStore({ 
  reducer,
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  devTools: process.env.REACT_APP_ENV !== 'production'
});


//////////////////////////////////////////
// locale
//////////////////////////////////////////
let locale = getLanguage(navigator.language);

let messages;
if (locale === "en") {
  messages = messages_en;
} else if (locale === "zh") {
  messages = messages_zh;
} else {
  messages = messages_en;
}

function getLanguage(locale) {
  const dashIndex = locale.indexOf("-");
  if (dashIndex >= 0) {
    return locale.substring(0, dashIndex);
  }
  return locale;
}

ReactDOM.render(
    <Provider store={store}>
      <Router>
          <IntlProvider
          locale={locale}
          key={locale}
          defaultLocale="en"
          messages={messages}>
              <PaymentsApplication />
          </IntlProvider>
      </Router>
    </Provider>,
    document.getElementById('root')
);

//serviceWorker.register();
